// extracted by mini-css-extract-plugin
export default {"subsidyFeeding":"LeftBarContent_subsidyFeeding__aHs62","photo":"LeftBarContent_photo__mOdUC","placeHolderShimmer":"LeftBarContent_placeHolderShimmer__uKRAg"};